import { useState, useEffect } from "react";
import { BrutalistEditorial } from "./components/variations/BrutalistEditorial";
import { ResumePage } from "./components/ResumePage";
import "./index.css";

function useRoute() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const navigate = (to: string) => {
    history.pushState(null, "", to);
    setPath(to);
  };

  return { path, navigate };
}

export function App() {
  const { path, navigate } = useRoute();

  if (path === "/resume") {
    return <ResumePage navigate={navigate} />;
  }

  return <BrutalistEditorial navigate={navigate} />;
}

export default App;
